import { createFileRoute } from '@tanstack/react-router'
import { Navbar } from '@/components/landing/navbar'
import { Hero } from '@/components/landing/hero'
import { HowItWorks } from '@/components/landing/how-it-works'
import { SupportedServices } from '@/components/landing/supported-services'
import { CountryPricing } from '@/components/landing/country-pricing'
import { Features } from '@/components/landing/features'
import { AppPreview } from '@/components/landing/app-preview'
import { Testimonials } from '@/components/landing/testimonials'
import { CtaBanner } from '@/components/landing/cta-banner'
import { Footer } from '@/components/landing/footer'

export const Route = createFileRoute('/')({
  component: Index,
})

function Index() {
  return (
    <div
      style={{
        background: '#F8FAFF',
        minHeight: '100vh',
        fontFamily: '"Plus Jakarta Sans", "DM Sans", sans-serif',
        color: '#111827',
        overflowX: 'hidden',
      }}
    >
      <Navbar />
      <Hero />
      <HowItWorks />
      <SupportedServices />
      <CountryPricing />
      <Features />
      <AppPreview />
      <Testimonials />
      <CtaBanner />
      <Footer />
    </div>
  )
}
